export const FORMAT_HEADING_1_MENU_ITEM = {
	key: 'block-menu-format-heading-1',
};

export const FORMAT_HEADING_2_MENU_ITEM = {
	key: 'block-menu-format-heading-2',
};

export const FORMAT_HEADING_3_MENU_ITEM = {
	key: 'block-menu-format-heading-3',
};

export const FORMAT_HEADING_4_MENU_ITEM = {
	key: 'block-menu-format-heading-4',
};

export const FORMAT_HEADING_5_MENU_ITEM = {
	key: 'block-menu-format-heading-5',
};

export const FORMAT_HEADING_6_MENU_ITEM = {
	key: 'block-menu-format-heading-6',
};

export const FORMAT_PARAGRAPH_MENU_ITEM = {
	key: 'block-menu-format-paragraph',
};

export const FORMAT_QUOTE_MENU_ITEM = {
	key: 'block-menu-format-quote',
};

export const FORMAT_EXPAND_MENU_ITEM = {
	key: 'block-menu-format-expand',
};

export const FORMAT_LAYOUT_MENU_ITEM = {
	key: 'block-menu-format-layout',
};

export const FORMAT_PANEL_MENU_ITEM = {
	key: 'block-menu-format-panel',
};

export const FORMAT_CODE_BLOCK_MENU_ITEM = {
	key: 'block-menu-format-code-block',
};

export const FORMAT_BULLETED_LIST_MENU_ITEM = {
	key: 'block-menu-format-bulleted-list',
};

export const FORMAT_NUMBERED_LIST_MENU_ITEM = {
	key: 'block-menu-format-numbered-list',
};

export const FORMAT_TASK_LIST_MENU_ITEM = {
	key: 'block-menu-format-task-list',
};

export const NESTED_FORMAT_MENU = {
	key: 'nested-menu-format',
};

export const PRIMARY_MENU_SECTION = {
	key: 'block-menu-section-primary',
};

export const NESTED_FORMAT_MENU_SECTION = {
	key: 'nested-menu-format-section-primary',
};

export const ADD_BLOCKS_MENU_SECTION = {
	key: 'block-menu-section-synced-block',
};

export const COPY_MENU_SECTION = {
	key: 'block-menu-section-copy',
};

export const DELETE_MENU_SECTION = {
	key: 'block-menu-section-delete',
};

export const MOVE_UP_DOWN_MENU_SECTION = {
	key: 'block-menu-section-move-up-down',
};

export const FORMAT_MENU_ITEM = {
	key: 'nested-menu-format-section-primary',
};

export const CREATE_SYNCED_BLOCK_MENU_ITEM = {
	key: 'block-menu-create-synced-block',
};

export const COPY_BLOCK_MENU_ITEM = {
	key: 'block-menu-copy-block',
};

export const COPY_LINK_MENU_ITEM = {
	key: 'block-menu-item-copy-link',
};

export const MOVE_UP_MENU_ITEM = {
	key: 'block-menu-item-move-up',
};

export const MOVE_DOWN_MENU_ITEM = {
	key: 'block-menu-item-move-down',
};

export const DELETE_MENU_ITEM = {
	key: 'block-menu-item-delete',
};
